module.exports = __webpack_public_path__ + "static/media/La Alegria del Valle.dea9ab8a.jpg";